import template from './positionsPanels.html';
import controller from './positionsPanels.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
  }
};

export default component;
